export const config = {
  massFlow: {
    title: 'Mass Flow Rate',
    number: {
      floor: 1,
      ceiling: 100,
      millisec: 1000,
    },
    unit: 'gram/s',
  },

  driveGain: {
    title: 'Drive Gain',
    number: 1,
    unit: '%',
  },

  temperature: {
    title: 'Temperature',
    number: 32,
    unit: '°C',
  },

  density: {
    title: 'Density',
    number: 1,
    unit: 'g/cm3',
  },

  volFwdTotal: {
    title: 'Vol Fwd Total',
    number: 0,
    unit: '[unit]',
  },

  volFlowRate: {
    title: 'Volume Flow Rate',
    number: 0,
    unit: 'L/s',
  },

  massFwdTotal: {
    title: 'Mass Fwd Total',
    number: 0,
    unit: '[unit]',
  },
};
